'use client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as yup from 'yup';
import iplLogoWhite from '../../../public/assets/images/IPL_Logo_Text_White_SmallScale.webp';

import { faFacebook, faInstagram, faLinkedin, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faHouse, faPhone } from '@fortawesome/free-solid-svg-icons';
import Image from 'next/image';
import Link from 'next/link';
import { useOutsideClick } from 'outsideclick-react';
import { memo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonAction from '../../redux/actions/common';

const userSchema = yup.object().shape({
    name: yup.string().required('Name  is required'),
    email: yup.string().email().required('Email is required'),
    message: yup.string().required('Message  is required'),
});
const PartnersFooterSection = ({ sendFeedback }: any) => {
    const [messageData, setMessageData] = useState({
        name: '',
        email: '',
        message: '',
    });
    const [successMessage, setSuccessMessage] = useState('');
    const [errors, setErrors] = useState<any>({});

    const handleChangeLanding = (e: any) => {
        const { name, value } = e.target;
        setMessageData((pre) => {
            return {
                ...pre,
                [name]: value,
            };
        });
        validateField(e.target.name, e.target.value);
    };
    const validateField = async (fieldName: string, value: string) => {
        try {
            await (yup.reach(userSchema, fieldName) as yup.StringSchema).validate(value);
            setErrors({ ...errors, [fieldName]: '' });
        } catch (error: any) {
            setErrors({ ...errors, [fieldName]: error.message });
        }
    };
    const handleSubmit = async () => {
        try {
            await userSchema.validate(
                {
                    name: messageData?.name,
                    email: messageData?.email, // Replace convertToHtml with the actual function to convert editorState to HTML
                    message: messageData?.message,
                },
                { abortEarly: false }
            );
            const data = {
                name: messageData?.name,
                email: messageData?.email, // Replace convertToHtml with the actual function to convert editorState to HTML
                message: messageData?.message,
            };

            sendFeedback(data).then((res: any) => {
                if (res?.code === 200) {
                    setSuccessMessage(res?.message);
                }
                setMessageData({
                    name: '',
                    email: '',
                    message: '',
                });
            });
        } catch (error: any) {
            const newErrors: any = {};
            error.inner.forEach((e: { path: any; message: any }) => {
                newErrors[e.path] = e.message;
            });
            setErrors(newErrors);
        }
    };
    const handleOutsideClick = (e: any) => {
        setErrors({});
        setSuccessMessage('');
    };
    const ref = useOutsideClick(handleOutsideClick);
    const getYear = () => new Date().getFullYear();
    return (
        <section className="footer-landing py-4 mt-3 ">
            <div>
                <h4 className="text-center text-white title-text-color-landing ">GET IN TOUCH</h4>
            </div>
            <div className="container-fluid px-lg-3">
                <div className="row px-3">
                    <div className="col-lg-6">
                        <div>
                            <form ref={ref}>
                                <div className="row gap-2 mt-3">
                                    <div className="col">
                                        <input
                                            className="text-input-landing"
                                            value={messageData?.name}
                                            name="name"
                                            placeholder="Name"
                                            onChange={handleChangeLanding}
                                        />
                                        {errors.name && <p className="error-message mt-1 px-1">{errors.name}</p>}
                                    </div>
                                    <div className="col">
                                        <input
                                            className="text-input-landing"
                                            value={messageData?.email}
                                            name="email"
                                            placeholder="Email"
                                            onChange={handleChangeLanding}
                                        />
                                        {errors.email && <p className="error-message mt-1 px-1">{errors.email}</p>}
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col">
                                        <textarea
                                            className="text-input-landing"
                                            value={messageData?.message}
                                            name="message"
                                            placeholder="Message"
                                            style={{ height: '100px' }}
                                            onChange={handleChangeLanding}
                                        />
                                        {errors.message && <p className="error-message mt-1 px-1">{errors.message}</p>}
                                        {successMessage !== '' && <p className="border text-white mt-2 px-1 py-3">{successMessage}</p>}
                                    </div>
                                </div>
                                <div>
                                    <button type="button" className="btn-landing-submit" onClick={handleSubmit}>
                                        Send Message
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="d-flex justify-content-center mt-3">
                            <ul className="footer-address-landing " style={{ fontSize: 15 }}>
                                <li>
                                    <div className="d-flex gap-2">
                                        <div>
                                            <FontAwesomeIcon icon={faHouse} size="lg" color="#fff" />
                                        </div>
                                        <div className="footer-address-li">
                                            <a
                                                href="https://maps.app.goo.gl/LXUXTf3kdGBFPdMEA"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-decoration-none text-white"
                                            >
                                                56 S. LaSalle St. Suite 106 Aurora, IL 60505 USA
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li className="my-4">
                                    <div className="d-flex gap-2">
                                        <div>
                                            <FontAwesomeIcon icon={faPhone} size="lg" color="#fff" />
                                        </div>
                                        <div className="footer-address-li">
                                            <a href="tel:(630) 870-1101" className="text-decoration-none text-white ">
                                                (630) 870-1101
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="d-flex gap-2 mt-2">
                                        <div>
                                            <FontAwesomeIcon icon={faEnvelope} size="lg" color="#fff" />
                                        </div>
                                        <div className="footer-address-li">
                                            <a className="text-decoration-none text-white " href="mailto:info@sqxbonds.com">
                                                info@sqxbonds.com
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-3 d-flex flex-column justify-content-between mt-3" style={{ height: '110px' }}>
                        <div className="d-flex justify-content-betwee gap-3 ms-1" style={{ maxWidth: '300px' }}>
                            <a
                                className="text-decoration-none"
                                href="https://www.linkedin.com/company/sqxbonds/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faLinkedin} size="2x" color="#fff" />
                            </a>
                            <a
                                className="text-decoration-none"
                                href="https://www.facebook.com/profile.php?id=100092449088794"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faFacebook} size="2x" color="#fff" />
                            </a>
                            <a
                                className="text-decoration-none"
                                href="https://www.instagram.com/sqxbonds/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faInstagram} size="2x" color="#fff" />
                            </a>
                            <a className="text-decoration-none" href="https://x.com/SQXBonds" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faXTwitter} size="2x" color="#fff" />
                            </a>
                        </div>
                        <div>
                            <a href="https://information-publishing.com/" target="_blank" rel="noopener noreferrer">
                                <Image
                                    loading="lazy"
                                    src={iplLogoWhite}
                                    alt="ipl-logo"
                                    width={140}
                                    className="img-fluid p-0 m-0"
                                    style={{ objectFit: 'contain' }}
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <div>
                            <p className="text-white text-center mt-3">
                                © {getYear()} SQX Bonds. All rights reserved |{' '}
                                <Link
                                    href="/privacy-policy"
                                    className="text-white text-decoration-underline"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Privacy Policy
                                </Link>{' '}
                                |{' '}
                                <Link
                                    href="/terms-and-condition"
                                    className="text-white text-decoration-underline"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Terms and Conditions
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators(
        {
            ...commonAction,
        },
        dispatch
    );
};

export default memo(connect(null, mapDispatchToProps)(PartnersFooterSection));
// export default partnersFooterSection
